// extracted by mini-css-extract-plugin
module.exports = {"desc":"Box_desc__CuBGh","descDiv":"Box_descDiv__2zlsZ","descNoBorderDiv":"Box_descNoBorderDiv__2EoQc","descNoBorder":"Box_descNoBorder__3FEkJ"};